module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/cgi-offer.9a8ebb9d.png";